import React from 'react'
import { Link } from 'react-router-dom'

function ErrorPage() {
    return (
        <section className="error-404 section-space">
            <div className="container">
                <div className="error-404__content">
                    <img src="/assets/images/404-error-1-1.webp" alt="404 Error" className="error-404__image" />
                    <h2 className="error-404__title">404</h2>
                    <h3 className="error-404__sm-title">Sahifa topilmadi!</h3>
                    <p className="error-404__text">
                        Ushbu sahifa mavjud emas yoki o'chirilgan. Pastdagi tugma bilan bosh sahifaga qayting.
                    </p>
                    <Link to="/" className="eduhive-btn eduhive-btn--normal"><span>Bosh sahifaga qaytish</span></Link>
                </div>
            </div>
        </section>
    )
}

export default ErrorPage